import React from "react";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


export default function DeleteTaskDialog({selectedWord, openDeleteDialog, handleClose, handleDelete}) {

    return(
        <Dialog
        open={openDeleteDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        name="delete-dialog"
      >
        <DialogTitle id="alert-dialog-title">{`Delete ${selectedWord?.name} word`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this word?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id="dismiss" onClick={handleClose} color="primary">
            No
          </Button>
          <Button id="confirm" onClick={handleDelete} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    )
}